// extracted by mini-css-extract-plugin
module.exports = {"details":"style_details__34Txx","issue-complete":"style_issue-complete__MGxp9","input-container":"style_input-container__2z-FU"};